/**
 * @flow
 * @relayHash a6acaf7fcc8a3b95c3a0dcacab085380
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeepPagesTable_project$ref = any;
export type indexing_IndexingCategory_DeepPagesTable_QueryVariables = {|
  host: string
|};
export type indexing_IndexingCategory_DeepPagesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DeepPagesTable_project$ref
  |}
|};
export type indexing_IndexingCategory_DeepPagesTable_Query = {|
  variables: indexing_IndexingCategory_DeepPagesTable_QueryVariables,
  response: indexing_IndexingCategory_DeepPagesTable_QueryResponse,
|};
*/


/*
query indexing_IndexingCategory_DeepPagesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...DeepPagesTable_project
    id
  }
}

fragment DeepPagesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesDeepPages(errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          type
          count
          severity
        }
        deepPages(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}, depthOrder: -1, errorUrl: {operator: AND, values: []}, typeFilters: []) {
          count
          edges {
            node {
              ...DeepPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DeepPagesRow_issue on DeepPage {
  id
  type
  severity
  depth
  error_url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "errorUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "indexing_IndexingCategory_DeepPagesTable_Query",
  "id": null,
  "text": "query indexing_IndexingCategory_DeepPagesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...DeepPagesTable_project\n    id\n  }\n}\n\nfragment DeepPagesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesDeepPages(errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          type\n          count\n          severity\n        }\n        deepPages(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}, depthOrder: -1, errorUrl: {operator: AND, values: []}, typeFilters: []) {\n          count\n          edges {\n            node {\n              ...DeepPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DeepPagesRow_issue on DeepPage {\n  id\n  type\n  severity\n  depth\n  error_url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "indexing_IndexingCategory_DeepPagesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DeepPagesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "indexing_IndexingCategory_DeepPagesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesDeepPages",
                        "storageKey": "countTypesDeepPages(errorUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "deepPages",
                        "storageKey": "deepPages(depthOrder:-1,errorUrl:{\"operator\":\"AND\",\"values\":[]},limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},typeFilters:[])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "depthOrder",
                            "value": -1,
                            "type": "Int"
                          },
                          v4,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v5,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "DeepPagesConnection",
                        "plural": false,
                        "selections": [
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DeepPagesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DeepPage",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v6,
                                  v8,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "depth",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "error_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e084fdd2c8c9ebcfc582b0fbb6708262';
module.exports = node;
